import React from 'react'
import Box from '../UI';
import { Typography, Divider } from '@material-ui/core';

export default function Header({ title, subtitle, children, action }) {
    return (
        <>
            <Box display='flex' flexDirection={['column', 'column', 'column', 'row']} justifyContent='space-between' mb={2}>
                <Box mb={[1, 1, 1, 0]} display='flex' alignItems='center'>
                    <Box>{action}</Box>
                    <Box>
                        <Typography variant="h4"><strong>{title}</strong></Typography>
                        {subtitle && <Typography variant="h5" color='textSecondary'><strong>{subtitle}</strong></Typography>}
                    </Box>
                </Box>
                <Box flexGrow={1} ml={[0, 0, 0, 4]} display='flex' justifyContent={['flex-start', 'flex-start', 'flex-start', 'flex-end']}>
                    {children}
                </Box>
            </Box>
            <Divider style={{ marginBottom: '2rem' }} />
        </>
    )
}
